import React, { Component, PropTypes } from 'react';
import ReactDOM, { findDOMNode } from 'react-dom';
import { connect } from 'react-redux'
import PageToolDropdown from './PageToolDropdown'
import JoomlaActions from './JoomlaActions'
import { addRow, saveSetting } from '../actions/index'
import { ActionCreators } from 'redux-undo';
import { importPage } from '../actions/index'
import AllAddonList from './AllAddonList'
import EditPanel from './EditPanel'
import SectionLibrary from './SectionLibrary';
import MySection from './MySection';
import withDragDropContext from '../helpers/withDragDropContext';
import EditPanelManager from '../helpers/EditPanelManager';
import _ from 'lodash';
import ResponsiveManager from '../helpers/ResponsiveManager';

class PageTools extends Component{

  constructor(props) {
    super(props);

    this.updateState = this.updateState.bind(this);
    this.updateResponsiveData = this.updateResponsiveData.bind(this);

    this.state = {
      isEditPanelOn: EditPanelManager.show,
      addonToEdit: EditPanelManager.addon,
      toggleType: EditPanelManager.type,
      rowIndex: EditPanelManager.rowIndex,
      innerRowIndex: EditPanelManager.innerRowIndex,
      innerColIndex: EditPanelManager.innerColIndex,
      colIndex: EditPanelManager.colIndex,
      rowSettings: EditPanelManager.rowSettings,
      colSettings: EditPanelManager.colSettings,
      currentPanel: 'addons',
      responsiveDevice: ResponsiveManager.device
    };
  }

  componentDidMount(){
    EditPanelManager.on('change', this.updateState);
    ResponsiveManager.on('change', this.updateResponsiveData);
  }

  componentWillUnmount(){
    EditPanelManager.removeListener('change', this.updateState);
    ResponsiveManager.removeListener('change', this.updateResponsiveData);
  }

  updateState(){
    this.setState({
      isEditPanelOn: EditPanelManager.show,
      addonToEdit: EditPanelManager.addon,
      toggleType: EditPanelManager.type,
      rowIndex: EditPanelManager.rowIndex,
      innerRowIndex: EditPanelManager.innerRowIndex,
      innerColIndex: EditPanelManager.innerColIndex,
      colIndex: EditPanelManager.colIndex,
      rowSettings: EditPanelManager.rowSettings,
      colSettings: EditPanelManager.colSettings,
    });

    if(!EditPanelManager.show){
      this.setState({
        currentPanel: 'addons'
      })
    }
  }

  updateResponsiveData(){
    let iframe = document.getElementById('sp-pagebuilder-view');

    if(ResponsiveManager.device == 'sm'){
      iframe.classList.add('sppb-tabel-view');
      iframe.classList.remove('sppb-mobile-view');
    } else if(ResponsiveManager.device == 'xs'){
      iframe.classList.add('sppb-mobile-view');
      iframe.classList.remove('sppb-tabel-view');
    } else {
      iframe.classList.remove('sppb-tabel-view', 'sppb-mobile-view');
    }
    this.setState({
      responsiveDevice: ResponsiveManager.device
    });
  }

  uploadPage(){
    var file = jQuery('#upload-file').prop('files')[0];

    if (typeof file === 'undefined') {
      return;
    }

    var fileName = file.name,
        fileType = fileName.slice(-5),
        fileTypeLower = fileType.toLowerCase();

    if (fileTypeLower === '.json') {
      var formData = new FormData();
      formData.append('page',file );
      jQuery.ajax({
        type: 'POST',
        url: pagebuilder_base + 'index.php?option=com_sppagebuilder&view=ajax&format=json&callback=upload-page&editarea=frontend',
        dataType: 'json',
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
        success: function(response) {
          if ( response.status ) {
            this.props.importPage(JSON.parse(response.data));
            jQuery('#upload-file').val('');
          } else {
            // console.log(response.data);
          }
        }.bind(this)
      });
    }
  }

  saveSettings(values){

    if(this.state.toggleType == 'addon' || this.state.toggleType == 'inner_addon'){
      let editedAddon = {
        type: this.state.toggleType,
        index: this.state.addonToEdit.index,
        settings: {
          colIndex: this.state.addonToEdit.settings.colIndex,
          addonIndex: this.state.addonToEdit.settings.addonIndex,
          addonId: this.state.addonToEdit.settings.addonId,
          htmlContent: this.state.addonToEdit.settings.htmlContent,
          assets: this.state.addonToEdit.settings.assets,
          addonName: this.state.addonToEdit.settings.addonName,
          formData: values
        }
      };

      if(this.state.toggleType == 'inner_addon'){
        editedAddon.settings.innerRowIndex = this.state.addonToEdit.settings.innerRowIndex;
        editedAddon.settings.innerColIndex = this.state.addonToEdit.settings.innerColIndex;
        editedAddon.settings.addonInnerIndex = this.state.addonToEdit.settings.addonInnerIndex;
      }

      let addonOpsTemp = addonsJSON[this.state.addonToEdit.settings.addonName];

      if(addonOpsTemp.js_template){
        this.props.onSettingsClick(editedAddon);
      } else {
        document.body.classList.add('sppb-loading-btn-active')
        jQuery.ajax({
          type: 'POST',
          url: pagebuilder_base + 'index.php?option=com_sppagebuilder&view=ajax&format=json&callback=addon',
          dataType: 'json',
          data: {
            addon: {
              id: editedAddon.settings.addonId,
              settings: values,
              name: editedAddon.settings.addonName
            }
          },
          cache: false,
          success: function(response) {
            editedAddon.settings.htmlContent = response.html;
            editedAddon.settings.assets = response.assets;

            this.props.onSettingsClick(editedAddon);
            document.body.classList.remove('sppb-loading-btn-active')
          }.bind(this)
        });
      }


    } else if(this.state.toggleType == 'row' || this.state.toggleType == 'inner_row'){
      let editedRow = {
        type: this.state.toggleType,
        index: this.state.rowIndex,
        settings: {
          colIndex: this.state.colIndex,
          addonIndex: this.state.innerRowIndex,
          formData: values
        }
      };

      this.props.onSettingsClick(editedRow);
    }  else if(this.state.toggleType == 'column' || this.state.toggleType == 'inner_column'){
      let editedCol = {
        type: this.state.toggleType,
        index: this.state.rowIndex,
        settings: {
          formData: values,
          colIndex: this.state.colIndex,
          addonIndex: this.state.innerRowIndex,
          innerColIndex: this.state.innerColIndex,
        }
      };
      this.props.onSettingsClick(editedCol);
    }


  }

  changeDevice(e){
    e.preventDefault();
    let currentDevice = findDOMNode(this).querySelector('.sp-pagebuilder-device-option > ul > li > a.active');
    let newDevice = e.currentTarget;
    let deviceId = newDevice.dataset.device;

    if(deviceId == 'tablet'){
      ResponsiveManager.setDevice('sm');
    } else if(deviceId == 'mobile'){
      ResponsiveManager.setDevice('xs');
    } else {
      ResponsiveManager.setDevice('md');
    }

  }

  render(){
    const { pageBuilder } = this.props.state;
    const { responsiveDevice } = this.state;
    let undoCount = pageBuilder.past.length;
    let redoCount = pageBuilder.future.length;


    let addonListClass = '';
    let sectionListClass = '';
    let mySectionListClass = '';

    let showAddonList = true;
    let showSectionList = true;
    let showMySection = true;

    if(this.state.isEditPanelOn || this.state.currentPanel != 'addons'){
      addonListClass = 'sppb-hidden';
      showAddonList = false
    }

    if(this.state.isEditPanelOn || this.state.currentPanel != 'section'){
      sectionListClass = 'sppb-hidden';
      showSectionList = false
    }

    if(this.state.isEditPanelOn || this.state.currentPanel != 'mysection'){
      mySectionListClass = 'sppb-hidden';
      showMySection = false
    }

    let activeAddons = '';
    let activeSection = '';
    let activeMySection = '';

    if(this.state.currentPanel == 'addons'){
      activeAddons = 'active';
    } else if(this.state.currentPanel == 'section'){
      activeSection = 'active';
    } else if(this.state.currentPanel == 'mysection'){
      activeMySection = 'active';
    }

    let panelTitle = ''
    let uniqueId = 1223123124142134;
    if((this.state.toggleType == 'addon' || this.state.toggleType == 'inner_addon') && !_.isEmpty(this.state.addonToEdit)){
      panelTitle = addonsJSON[this.state.addonToEdit.settings.addonName].title
      uniqueId = this.state.addonToEdit.settings.addonId
    } else if(this.state.toggleType == 'row') {
      panelTitle = 'Section'
      uniqueId = this.state.rowSettings.id
    } else if(this.state.toggleType == 'inner_row') {
      panelTitle = 'Inner Section'
      uniqueId = this.state.rowSettings.id
    } else if(this.state.toggleType == 'column') {
      panelTitle = 'Column'
      uniqueId = this.state.colSettings.id
    } else if(this.state.toggleType == 'inner_column') {
      panelTitle = 'Inner Column'
      uniqueId = this.state.colSettings.id
    }
    
    return(
      <div key={uniqueId} className="clearfix">
        <input
          type="file"
          name="upload-file"
          id="upload-file"
          accept=".json"
          style={{ display:'none'}}
          onChange={ (e) => {
            this.uploadPage();
          }}
          />
        <div className="sp-pagebuilder-topbar">
          {
            this.state.isEditPanelOn  ?
            <span className="sp-pagebuilder-addon-edit">
              <button className="sp-pagebuilder-close-edit" onClick={e => {
                EditPanelManager.hideEditPanel()
                }}><i className="fa fa-long-arrow-left"></i> Back</button>
                {_.capitalize(panelTitle)}
            </span>
            :
            <span className="sp-pagebuilder-title">
              SP Page Builder <strong>{ sppbVersion }</strong>
            </span>
          }
          <div className="sppb-edit-show-hide" onClick={e => {
              e.preventDefault();
              if(document.body.classList.contains('sppb-full-view')){
                document.body.classList.remove('sppb-full-view')
              } else {
                document.body.classList.add('sppb-full-view')
              }
            }}><i className="fa fa-angle-left"></i></div>
        </div>
        {
          !this.state.isEditPanelOn &&
          <div className="sp-pagebuilder-main-tab">
            <ul className="clearfix">
              <li><a href="#" className={activeAddons} onClick={e => {
                  e.preventDefault();
                  this.setState({
                    currentPanel: 'addons'
                  })
                }}>Addons</a></li>
              <li><a href="" className={activeSection} onClick={e => {
                  e.preventDefault();
                  this.setState({
                    currentPanel: 'section'
                  })
                }}>Sections</a></li>
              <li><a href="" className={activeMySection} onClick={e => {
                  e.preventDefault();
                  this.setState({
                    currentPanel: 'mysection'
                  })
                }}>Library</a></li>
            </ul>
          </div>
        }

        {
          this.state.isEditPanelOn &&
          <EditPanel
            uniqueId={uniqueId}
            addon={this.state.addonToEdit}
            onSaveSettings={this.saveSettings.bind(this)}
            toggleType={this.state.toggleType}
            rowSettings={this.state.rowSettings.settings}
            colSettings={this.state.colSettings.settings}
          />

        }
        {
          showAddonList &&
          <div className={addonListClass}>
            <AllAddonList />
          </div>
        }
        {
          showSectionList &&
          <div className={sectionListClass}>
            <SectionLibrary />
          </div>
        }
        
        {
          showMySection &&
          <div className={mySectionListClass}>
            <MySection />
          </div>
        }
        

        <div className="sp-pagebuilder-device-option">
          <ul>
            {
              responsiveDevice == 'md'
              ?
              <li><a href="#" data-device="desktop" id="sppb-device-desktop" className="active" onClick={this.changeDevice.bind(this)}><i className="fa fa-laptop"></i></a></li>
              :
              <li><a href="#" data-device="desktop" id="sppb-device-desktop" onClick={this.changeDevice.bind(this)}><i className="fa fa-laptop"></i></a></li>
            }
            {
              responsiveDevice == 'sm'
              ?
              <li><a href="#" data-device="tablet" id="sppb-device-tablet" className="active" onClick={this.changeDevice.bind(this)}><i className="fa fa-tablet"></i></a></li>
              :
              <li><a href="#" data-device="tablet" id="sppb-device-tablet" onClick={this.changeDevice.bind(this)}><i className="fa fa-tablet"></i></a></li>
            }

            {
              responsiveDevice == 'xs'
              ?
              <li><a href="#" data-device="mobile" id="sppb-device-mobile" className="active" onClick={this.changeDevice.bind(this)}><i className="fa fa-mobile"></i></a></li>
              :
              <li><a href="#" data-device="mobile" id="sppb-device-mobile" onClick={this.changeDevice.bind(this)}><i className="fa fa-mobile"></i></a></li>
            }

          </ul>
        </div>

        <div className="sp-pagebuilder-action-bar">
          <div className="">
            <ul className="sp-pagebuilder-page-tabs">

              <li>
                <a href="#" onClick={e => {
                    e.preventDefault();
                    Joomla.submitform('page.cancel');
                  }}><i className="fa fa-times"></i></a>
              </li>

              <li className="sp-pagebuilder-redo-undo">
                <button
                  type="button"
                  className="sp-pagebuilder-btn sp-pagebuilder-btn-link"
                  disabled={
                    !undoCount&&
                    'disabled'
                  }
                  onClick={ (e) => {
                    e.preventDefault();
                    this.props.pageUndoClick();
                    EditPanelManager.hideEditPanel();
                  }}
                  >
                  <span><i className="pbfont pbfont-undo"></i></span>
                </button>
              </li>
              <li className="sp-pagebuilder-redo-undo">
                <button
                  className="sp-pagebuilder-btn sp-pagebuilder-btn-link"
                  type="button"

                  disabled={
                    !redoCount&&
                    'disabled'
                  }
                  onClick={ (e) => {
                    e.preventDefault();
                    this.props.pageRedoClick();
                    EditPanelManager.hideEditPanel();
                  }}
                  >
                  <span><i className="pbfont pbfont-redo"></i></span>
                </button>
              </li>
              <li className="sp-pagebuilder-tools-btn">
                <PageToolDropdown />
              </li>

              <li className="sp-pagebuilder-save-btn">
                <a href="#" id="btn-save-page" className="sp-pagebuilder-btn sp-pagebuilder-btn-primary"><i className="fa fa-save"></i> Save</a>
              </li>

            </ul>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ( state ) => {
  return {state};
}

const mapDispatchToProps = ( dispatch ) => {
  return {
    addNewRow: () => {
      dispatch(addRow())
    },
    pageUndoClick: () => {
      dispatch(ActionCreators.undo())
    },
    pageRedoClick: () => {
      dispatch(ActionCreators.redo())
    },
    importPage: ( page ) => {
      dispatch(importPage(page))
    },
    onSettingsClick: (options) => {
      dispatch(saveSetting(options))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withDragDropContext(PageTools));



// WEBPACK FOOTER //
// ./src/components/PageTools.js